module.exports = __webpack_public_path__ + "static/topgraphics-3-d14eb3faf40d9072f26ec025f6c305a2.png";